/**
 * サーバーの404エラー.
 */
export default class NotFoundException extends Error {}
